export default __webpack_public_path__ + "static/media/i-exterior - ins.56d1b81c.svg";